var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 65.278 65.277",
    style: {
      fill: "#163A5F",
      enableBackground: "new 0 0 65.278 65.277"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.606,63.148c0.353,0.387,0.434,0.938,0.207,1.404c-0.219,0.44-0.678,0.725-1.172,0.725h-7.188 c-0.354,0-0.696-0.145-0.94-0.396l-15.86-16.519l-0.53,0.009v15.63c0,0.704-0.583,1.276-1.299,1.276h-6.07 c-0.716,0-1.299-0.572-1.299-1.276V1.276C1.456,0.572,2.039,0,2.755,0h6.07c0.716,0,1.299,0.572,1.299,1.276v35.991l14.44-18.329 c0.241-0.309,0.625-0.494,1.024-0.494h7.537c0.484,0,0.927,0.264,1.152,0.688c0.237,0.441,0.185,0.982-0.132,1.379L16.66,42.385 L35.606,63.148z M63.17,18.348c-8.675,0-12.932,3.882-14.664,6.122v-5.322c0-0.359-0.291-0.65-0.65-0.65h-7.137 c-0.357,0-0.649,0.291-0.649,0.65l-0.007,45.478c0,0.173,0.07,0.343,0.189,0.458c0.12,0.123,0.289,0.193,0.463,0.193h8.174 c0.36,0,0.653-0.292,0.653-0.651V40.383c0-1.367,0.185-2.656,0.364-3.734c1.098-6.052,5.005-9.746,10.443-9.881h2.819 c0.173,0,0.343-0.07,0.459-0.19c0.125-0.123,0.193-0.287,0.193-0.462V19C63.824,18.64,63.531,18.348,63.17,18.348z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.477c9d8a006839bc78c58a9653801ea9.svg";
export { ForwardRef as ReactComponent };